import { TimeZone } from '../../../context'

function TimeZoneProvider({ children, timeZone }) {
  return <TimeZone value={timeZone}>{children}</TimeZone>
}

export default TimeZoneProvider
